<template>
  <div class="page flex-col">
    <div class="group_1 flex-col">
      <img
        class="image_1"
        referrerpolicy="no-referrer"
        src="../assets/header.png"
      />
      <router-link to="/view5"
        ><button class="homeBtn">首页</button></router-link
      >
      <div class="text-wrapper_01 flex-row justify-between">
        <span class="text_01">{{ y1 }}</span>
        <span class="text_01">{{ y2 }}</span>
      </div>
      <div class="section_2 flex-row">
        <router-link to="/view9">
          <div class="box_2 flex-col">
            <div class="box_3 flex-col">
              <span class="text_5">实时监控</span>
              <img
                class="thumbnail_1"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/psz996moc5yp810m609dnigziqcgz9h81g47350f407-ce42-453a-a0e8-d0a1b69be649"
              />
              <img
                class="thumbnail_2"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/psti81d8g6q9uopgipuvwli35zj1gyem0kc7f66e72-34f1-49b3-8d71-91da7a4883c3"
              />
              <img
                class="thumbnail_3"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/psvtrn8kmwijjmnpxmmy4ttnp7bln9s66a714b7d95-f612-4395-9983-dd2326210d20"
              />
              <img
                class="thumbnail_4"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps97m8eelzepivw13pzk5axmzm4isjk5eifc5067349-bafb-4f46-bdfc-13391215ed41"
              />
            </div>
          </div>
        </router-link>
      </div>
      <div class="section_3 flex-row justify-between"></div>
      <div class="section_4 flex-row justify-between">
        <div class="box_4 flex-col">
          <div class="section_5 flex-row">
            <!-- <span class="text_11">查找车位</span> -->
            <input
              type="text"
              placeholder="查找车位"
              class="text_11"
              v-model="parkSpace"
            />
            <div class="image-wrapper_3 flex-col" @click="searchParkSpace">
              <img
                class="thumbnail_8"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/psz69gqj7u2foruputdylcn965i5sqb8c0qc71a6d16-5f97-474e-9093-818b63717311"
              />
            </div>
          </div>
        </div>
        <div class="box_5 flex-col">
          <div class="block_3 flex-row justify-between">
            <div class="image-wrapper_4 flex-col align-center">
              <img
                class="thumbnail_9"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/psn3xbkkaevruqi5utjpz16b3em4rxglbd31417b5-0ba7-494c-b418-e324427f6d66"
              />
            </div>
            <span class="text_12">乌山九巷B1停车场</span>
          </div>
          <div class="block_4 flex-row">
            <img
              class="image_3"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/psy8fame9gg96om6qtlb0iciwz2vbyn5ih496649b7-91c7-49d4-bf1c-bb0d347a026e"
              @click="toggleTime('up')"
            />
            <div class="block_5 flex-row">
              <!-- <span class="text_13">2022-11-01&nbsp;&nbsp;10:00-11:00</span>
              <img
                class="thumbnail_10"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/psy6yxhtzu3zfnriioglhpzr2kpvwd9vfc6ff4a928-18a2-481f-a719-97ca9e8e264d"
              /> -->
              <select class="timeSelect" v-model="selectedValue">
                <option v-for="item in timeList" :value="item.value">
                  {{ item.time }}
                </option>
              </select>
            </div>
            <img
              class="image_4"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/psxqdrr3mv0edu4iwtwxk0lw4b86qhbelo18fa38fe-1ada-41b9-9cb6-b48acc475594"
              @click="toggleTime('down')"
            />
            <div class="block_6 flex-col">
              <div class="text-wrapper_3 flex-col">
                <span class="text_14">下转</span>
              </div>
            </div>
          </div>
          <div class="block_7 flex-row justify-between">
            <div class="block_8 flex-col justify-end">
              <span class="text_15"
                >2022年03月30日&nbsp;&nbsp;&nbsp;星期三&nbsp;&nbsp;11：31：35</span
              >
              <div class="section_6 flex-row">
                <span class="text_16">东北角摄像头画面</span>
                <div class="image-wrapper_5 flex-col">
                  <img
                    class="thumbnail_11"
                    referrerpolicy="no-referrer"
                    src="https://lanhu.oss-cn-beijing.aliyuncs.com/psde3c21voaajgifk7rgfta5p562mohzc8b7d22e90-3730-4c6e-9211-e78568fdea78"
                  />
                </div>
              </div>
            </div>
            <div class="block_9 flex-col">
              <span class="text_17"
                >2022年03月30日&nbsp;&nbsp;&nbsp;星期三&nbsp;&nbsp;11：31：35</span
              >
              <div class="box_6 flex-row">
                <span class="text_18">西北角摄像头画面</span>
                <div class="image-wrapper_6 flex-col">
                  <img
                    class="thumbnail_12"
                    referrerpolicy="no-referrer"
                    src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps9gxvhxfg13rsjl8y65xutp277eojx27px816a5b7e-f6f7-4272-896e-4240f15ef78e"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="block_7 flex-row justify-between">
            <div class="block_8 flex-col justify-end">
              <span class="text_15"
                >2022年03月30日&nbsp;&nbsp;&nbsp;星期三&nbsp;&nbsp;11：31：35</span
              >
              <div class="section_6 flex-row">
                <span class="text_16">东北角摄像头画面</span>
                <div class="image-wrapper_5 flex-col">
                  <img
                    class="thumbnail_11"
                    referrerpolicy="no-referrer"
                    src="https://lanhu.oss-cn-beijing.aliyuncs.com/psde3c21voaajgifk7rgfta5p562mohzc8b7d22e90-3730-4c6e-9211-e78568fdea78"
                  />
                </div>
              </div>
            </div>
            <div class="block_9 flex-col">
              <span class="text_17"
                >2022年03月30日&nbsp;&nbsp;&nbsp;星期三&nbsp;&nbsp;11：31：35</span
              >
              <div class="box_6 flex-row">
                <span class="text_18">西北角摄像头画面</span>
                <div class="image-wrapper_6 flex-col">
                  <img
                    class="thumbnail_12"
                    referrerpolicy="no-referrer"
                    src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps9gxvhxfg13rsjl8y65xutp277eojx27px816a5b7e-f6f7-4272-896e-4240f15ef78e"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section_7 flex-col">
        <div class="image-wrapper_7 flex-row">
          <img
            class="thumbnail_13"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/pspqlp2y7mge87ok3ol3xdgigzr1tbssqoe63822dc-e3c7-40e5-a5eb-13f66e4abd10"
          />
        </div>
        <div class="image-wrapper_8 flex-row">
          <img
            class="thumbnail_14"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps9b1h27cdwzq7amj0hlgblwnrf21oms9155b82ba-b7c9-4f7b-8e43-132fb3688829"
          />
        </div>
        <div class="image-wrapper_9 flex-row">
          <img
            class="thumbnail_15"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps07gjnfnikok7adpn0g46c6nlac0jompoz39fff103-a6b0-48bf-a139-80923fb84f13"
          />
        </div>
        <div class="image-wrapper_10 flex-row">
          <img
            class="thumbnail_16"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/pso4743022ummyipevdf7voiahc3cov4hm1453e3d4-046c-47b4-b5ed-2f2f4ce83d3d"
          />
        </div>
        <div class="image-wrapper_11 flex-row justify-between">
          <img
            class="thumbnail_17"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/psvaf2efvrjlr62ji41n6vahx7zd0rijnmc9c8ca43-642c-4d6e-83b2-cde0bc16bc70"
          />
          <img
            class="thumbnail_18"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/psru43mcbmnxhoqheepe5leyf2l3rw4eka3e8b7d4-d69c-44ab-b349-6e82898fc53c"
          />
        </div>
        <div class="image-wrapper_12 flex-row">
          <img
            class="thumbnail_19"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/psw9pmaoha739azto4z6tg1my8dovgyx8webcbc4a95-c0ef-4ab3-801e-218044c90458"
          />
        </div>
        <div class="image-wrapper_13 flex-row">
          <img
            class="thumbnail_20"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/psu6f88f9i3f29x0herabizn34qys4u2eb903e286-ea1f-4564-a07d-deb9c25ea890"
          />
        </div>
        <div class="image-wrapper_14 flex-row">
          <img
            class="thumbnail_21"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/pseianv8rji8r9it4to4t6ufyverv0orbqc0cb47bf-fde8-4a50-8aad-4e6d8b8c4fed"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var that;
var interval1;
export default {
  data() {
    return {
      constants: {},
      y1: "",
      y2: "",
      timeList: [
        {
          time: "2022-10-10 12:12 - 13:11",
          value: 0,
        },
        {
          time: "2022-10-10 14:12 - 11:12",
          value: 1,
        },
        {
          time: "2022-10-10 19:12 - 16:13",
          value: 2,
        },
        {
          time: "2022-10-10 19:12 - 16:14",
          value: 3,
        },
        {
          time: "2022-10-10 19:12 - 16:15",
          value: 4,
        },
      ],
      selectedValue: "",
      parkSpace: "",
    };
  },
  mounted() {
    that = this;
    interval1 = setInterval(function () {
      that.getTime();
    }, 1000);
    this.selectedValue = this.timeList[0].value;
  },
  methods: {
    searchParkSpace() {
      console.log(this.parkSpace);
    },
    toggleTime(direction) {
      console.log(direction);
      const currentIndex = this.selectedValue;
      if (direction === "up") {
        if (currentIndex > 0) {
          this.selectedValue = this.timeList[currentIndex - 1].value;
        }
      } else if (direction === "down") {
        if (currentIndex < this.timeList.length - 1) {
          this.selectedValue = this.timeList[currentIndex + 1].value;
        }
      }
    },
    getTime() {
      var date = new Date();
      var year = date.getFullYear();
      var mon = date.getMonth() + 1;
      var da = date.getDate(); //获取当前日

      var day = date.getDay();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      var submitTime = "";
      submitTime += year + "-";
      if (mon >= 10) {
        // submitTime += mon + "-";
      } else {
        mon = "0" + mon;
      }
      if (da >= 10) {
        // submitTime += day;
      } else {
        da = "0" + da;
      }
      submitTime += " ";
      if (h >= 10) {
        // submitTime += h + ":";
      } else {
        h = "0" + h;
      }
      if (m >= 10) {
        // submitTime += m;
      } else {
        m = "0" + m;
      }
      if (s < 10) {
        s = "0" + s;
      }
      var weeks = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      );
      this.y1 = year + "年" + mon + "月" + da + "日";
      this.y2 = weeks[day] + " " + h + ":" + m + ":" + s;
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  position: relative;
  width: 1980px;
  height: 1080px;
  overflow: hidden;
}

.group_1 {
  position: relative;
  width: 1980px;
  height: 1080px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psh2qd8rgahx8j4ehnlbt97i721tcn527828d0ad62-353b-44a6-9475-eeeba01d9dc0)
    100% no-repeat;
  background-size: 100% 100%;
}

.section_1 {
  width: 1916px;
  height: 90px;
  margin: 2px 0 0 31px;
}

.box_1 {
  width: 350px;
  height: 43px;
  margin-top: 38px;
}

.image_1 {
  width: 1900px;
  height: 94px;
}

.text-wrapper_1 {
  width: 339px;
  height: 19px;
  margin: 21px 0 0 11px;
}

.text_1 {
  width: 146px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}

.text_2 {
  width: 177px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}

.text-wrapper_2 {
  height: 90px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/pslvxiv43ugpk1n4k74id7rztmlo3vobhb9f636f65-3eae-4512-9f7f-8a3ac0a205be) -6px -6px
    no-repeat;
  background-size: 1345px 103px;
  margin-left: -55px;
  width: 1332px;
}

.text_3 {
  text-shadow: 0px 0px 13px rgba(23, 125, 230, 0.38);
  width: 704px;
  height: 51px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 70px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 70px;
  margin: 20px 0 0 310px;
}

.image_2 {
  width: 82px;
  height: 41px;
  margin: 16px 0 0 8px;
}

.text_4 {
  width: 170px;
  height: 34px;
  overflow-wrap: break-word;
  color: rgba(13, 204, 255, 1);
  font-size: 46px;
  font-family: PangMenZhengDao;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 46px;
  margin: 22px 0 0 29px;
}

.section_2 {
  width: 1143px;
  height: 38px;
  margin: 35px 0 0 790px;
}

.box_2 {
  height: 38px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps0n2e83bjnv9eucruwrnw29p7fd34hmden0d5e5338-db63-4861-993c-c4a1f7ac454b) -6px -6px
    no-repeat;
  background-size: 363px 49px;
  width: 351px;
}

.box_3 {
  height: 38px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps4jxvaggjasryk3cemkstahkfkhutkiuol86b27f2a-3a0e-4661-a604-85123e359fb4)
    0px 0px no-repeat;
  background-size: 352px 38px;
  width: 351px;
  position: relative;
}

.text_5 {
  width: 79px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 8px 0 0 136px;
}

.thumbnail_1 {
  position: absolute;
  left: -2px;
  top: 9px;
  width: 5px;
  height: 4px;
}

.thumbnail_2 {
  position: absolute;
  left: 348px;
  top: 9px;
  width: 5px;
  height: 4px;
}

.thumbnail_3 {
  position: absolute;
  left: -2px;
  top: 24px;
  width: 5px;
  height: 4px;
}

.thumbnail_4 {
  position: absolute;
  left: 348px;
  top: 24px;
  width: 5px;
  height: 4px;
}

.thumbnail_5 {
  width: 16px;
  height: 18px;
  margin-left: 650px;
}

.text_6 {
  width: 119px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 7px;
}

.section_3 {
  width: 902px;
  height: 356px;
  margin: 518px 0 41px 1021px;
}

.block_1 {
  width: 447px;
  height: 356px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/a98d0949803b4ebdb729c9360717f1d2_mergeImage.png)
    100% no-repeat;
  background-size: 100% 100%;
}

.text_7 {
  width: 257px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 15px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 15px;
  margin: 14px 0 0 11px;
}

.group_2 {
  width: 447px;
  height: 69px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps56vb0wixmmjfsi9pr3uh5qye4pqibbtngc9efce63-d0a5-4486-a1be-b1eb00632ec0)
    100% no-repeat;
  background-size: 100% 100%;
  margin: 259px 0 1px 1px;
}

.text_8 {
  width: 126px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 46px 0 0 15px;
}

.image-wrapper_1 {
  height: 23px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psup902y1q5xdg9a1yy9rkxuos0lwn4waud411c765-5d29-459c-a486-b7d96301a88b) -1px -1px
    no-repeat;
  background-size: 24px 24px;
  width: 23px;
  margin: 39px 8px 0 275px;
}

.thumbnail_6 {
  width: 13px;
  height: 13px;
  margin: 5px 0 0 5px;
}

.block_2 {
  width: 447px;
  height: 356px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/6fb9b92d8f1946ddb182126dd7471abd_mergeImage.png)
    100% no-repeat;
  background-size: 100% 100%;
}

.text_9 {
  width: 257px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 15px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 15px;
  margin: 14px 0 0 16px;
}

.group_3 {
  width: 447px;
  height: 51px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psdmq7mdj492mv3jse7nbqxjmtzn1yao1se640f310-5eab-4b07-8bb1-0f423ff4238c)
    100% no-repeat;
  background-size: 100% 100%;
  margin: 277px 0 1px 0;
}

.text_10 {
  width: 127px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 28px 0 0 14px;
}

.image-wrapper_2 {
  height: 23px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps68z9jz9rvy4dlulkzvrexee7vvvc2twiheb56a8d5-3655-4c95-8bc6-37eb7e545348) -1px -1px
    no-repeat;
  background-size: 24px 24px;
  width: 23px;
  margin: 21px 8px 0 275px;
}

.thumbnail_7 {
  width: 13px;
  height: 13px;
  margin: 5px 0 0 5px;
}

.section_4 {
  position: absolute;
  left: 25px;
  top: 186px;
  width: 1880px;
  height: 620px;
}

.box_4 {
  height: 620px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/pstyy2zo8jjxdc6s1vhwjrq4kck9tn2aso143c3afb-633f-4483-b60d-2b63897ff376)
    100% no-repeat;
  background-size: 100% 100%;
  width: 925px;
}

.section_5 {
  width: 215px;
  height: 35px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psmivv5yx1c95qwxpsqt73t8x0jdomm4g2e66542b0-060f-4609-a02b-f8a1c24bf379)
    100% no-repeat;
  background-size: 100% 100%;
  margin: 71px 0 0 20px;
}

.text_11 {
  width: 150px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(230, 230, 230, 1);
  font-size: 14px;
  font-family: SourceHanSansSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 11px 0 0 10px;
}

.image-wrapper_3 {
  height: 35px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/pszjso3jvd9bobfiv1u5af7jojkwr9tik24e37b503-1270-4f20-8f77-cc8e41fbb920) -1px
    0px no-repeat;
  background-size: 45px 35px;
  margin-left: 55px;
  width: 44px;
}

.thumbnail_8 {
  width: 18px;
  height: 17px;
  margin: 9px 0 0 13px;
}

.box_5 {
  width: 925px;
  height: 620px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psgmv6imjl31lis7kihetxyj193yxo297x2b979e6e3-42b4-4754-9eb6-fec42ec4f879)
    100% no-repeat;
  background-size: 100% 100%;
}

.block_3 {
  width: 237px;
  height: 25px;
  margin: 20px 0 0 30px;
}

.image-wrapper_4 {
  height: 15px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps2luafhkn1inh9bei6fi3zh9f1yu7o9ddw60456c28-6702-4648-95c4-3440cd2c2ab8)
    100% no-repeat;
  background-size: 100% 100%;
  margin-top: 4px;
  width: 14px;
}

.thumbnail_9 {
  width: 14px;
  height: 15px;
}

.text_12 {
  width: 213px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 26px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}

.block_4 {
  width: 640px;
  height: 41px;
  margin: 24px 0 0 280px;
}

.image_3 {
  width: 22px;
  height: 20px;
  margin-top: 9px;
}

.block_5 {
  width: 306px;
  height: 41px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps0fu04w5fny6ls5muu8mi3vmz2jy5f9e9ekb49be883-e222-496b-938e-665ca026a309) -1px
    0px no-repeat;
  background-size: 307px 41px;
  margin-left: 20px;
}

.text_13 {
  width: 208px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(87, 246, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin: 13px 0 0 18px;
}

.thumbnail_10 {
  width: 16px;
  height: 10px;
  margin: 16px 8px 0 56px;
}

.image_4 {
  width: 22px;
  height: 20px;
  margin: 15px 0 0 20px;
}

.block_6 {
  height: 40px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psub2e6owgj6fn0oyvtajxgj78lmzev4nfh77bc825e-1b55-4a0e-9d8b-3ea7adbb3738) -4px -4px
    no-repeat;
  background-size: 128px 46px;
  margin-left: 130px;
  width: 120px;
}

.text-wrapper_3 {
  height: 30px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psvq91y7a7acqqpvbogw7ssrvyar69c3yin820289fd-ee88-438e-9c08-c30cf729d3d0) -4px -4px
    no-repeat;
  background-size: 109px 36px;
  width: 101px;
  margin: 5px 0 0 8px;
}

.text_14 {
  text-shadow: 0px -4px 6px rgba(255, 255, 255, 0.56);
  width: 35px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(87, 246, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin: 6px 0 0 34px;
}

.block_7 {
  width: 902px;
  height: 357px;
  margin: 21px 0 0 13px;
}

.block_8 {
  width: 447px;
  height: 356px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/8a203b4bb5ac4170a657207391c5f4f4_mergeImage.png)
    100% no-repeat;
  background-size: 100% 100%;
}

.text_15 {
  width: 257px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 15px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 15px;
  margin: 13px 0 0 18px;
}

.section_6 {
  width: 447px;
  height: 69px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psuf6uajtjkhcq1hucew4oawo56vwzrdf98e9e464-856e-44db-95b8-0253cac33acf)
    100% no-repeat;
  background-size: 100% 100%;
  margin: 259px 0 0 1px;
}

.text_16 {
  width: 127px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 46px 0 0 14px;
}

.image-wrapper_5 {
  height: 23px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps6ptw0hji3av7rmmj1hyojqykcflmcu2e1690bab9-2f87-40f1-bba4-fc86b47d5646) -1px -1px
    no-repeat;
  background-size: 24px 24px;
  width: 23px;
  margin: 39px 8px 0 275px;
}

.thumbnail_11 {
  width: 13px;
  height: 13px;
  margin: 5px 0 0 5px;
}

.block_9 {
  width: 447px;
  height: 356px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/647ad264b751411e82bce7a241a46ba3_mergeImage.png)
    100% no-repeat;
  background-size: 100% 100%;
  margin-top: 1px;
}

.text_17 {
  width: 257px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 15px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 15px;
  margin: 12px 0 0 27px;
}

.box_6 {
  width: 447px;
  height: 51px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps7nfm1v2bqjnkdwns3tvfga6iz5e4pw1jd12a329e-dc1e-4d6b-a240-8fe64f12d44a)
    100% no-repeat;
  background-size: 100% 100%;
  margin: 277px 0 1px 0;
}

.text_18 {
  width: 126px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 28px 0 0 15px;
}

.image-wrapper_6 {
  height: 23px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/pscdvmnjd3q782mvjvvz0voozmjggwkl5ln4f0e6ff6-7a87-4797-8b26-2f45276a31d2) -1px -1px
    no-repeat;
  background-size: 24px 24px;
  width: 23px;
  margin: 21px 8px 0 275px;
}

.thumbnail_12 {
  width: 13px;
  height: 13px;
  margin: 5px 0 0 5px;
}

.section_7 {
  height: 723px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/f43830ccb6a94d5990e920954f0f55b6_mergeImage.png)
    100% no-repeat;
  background-size: 100% 100%;
  width: 890px;
  position: absolute;
  left: 44px;
  top: 317px;
}

.image-wrapper_7 {
  width: 17px;
  height: 19px;
  margin: 26px 0 0 53px;
}

.thumbnail_13 {
  width: 17px;
  height: 19px;
}

.image-wrapper_8 {
  width: 17px;
  height: 19px;
  margin: 19px 0 0 518px;
}

.thumbnail_14 {
  width: 17px;
  height: 19px;
}

.image-wrapper_9 {
  width: 17px;
  height: 19px;
  margin: 96px 0 0 847px;
}

.thumbnail_15 {
  width: 17px;
  height: 19px;
}

.image-wrapper_10 {
  width: 17px;
  height: 19px;
  margin: 79px 0 0 70px;
}

.thumbnail_16 {
  width: 17px;
  height: 19px;
}

.image-wrapper_11 {
  width: 320px;
  height: 25px;
  margin: 32px 0 0 425px;
}

.thumbnail_17 {
  width: 17px;
  height: 19px;
  margin-top: 6px;
}

.thumbnail_18 {
  width: 17px;
  height: 19px;
}

.image-wrapper_12 {
  width: 17px;
  height: 19px;
  margin: 116px 0 0 829px;
}

.thumbnail_19 {
  width: 17px;
  height: 19px;
}

.image-wrapper_13 {
  width: 17px;
  height: 19px;
  margin: 94px 0 0 274px;
}

.thumbnail_20 {
  width: 17px;
  height: 19px;
}

.image-wrapper_14 {
  width: 17px;
  height: 19px;
  margin: 11px 0 92px 70px;
}

.thumbnail_21 {
  width: 17px;
  height: 19px;
}
body * {
  box-sizing: border-box;
  flex-shrink: 0;
}
body {
  font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
    Arial, PingFang SC-Light, Microsoft YaHei;
}
input {
  background-color: transparent;
  border: 0;
}
button {
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
  background-color: transparent;
}

button:active {
  opacity: 0.6;
}
.van-nav-bar__left:active,
.van-nav-bar__right:active {
  opacity: 1;
}
[class*="van-"]::after {
  border-bottom: 0;
}
.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.justify-start {
  display: flex;
  justify-content: flex-start;
}
.justify-center {
  display: flex;
  justify-content: center;
}

.justify-end {
  display: flex;
  justify-content: flex-end;
}
.justify-evenly {
  display: flex;
  justify-content: space-evenly;
}
.justify-around {
  display: flex;
  justify-content: space-around;
}
.justify-between {
  display: flex;
  justify-content: space-between;
}
.align-start {
  display: flex;
  align-items: flex-start;
}
.align-center {
  display: flex;
  align-items: center;
}
.align-end {
  display: flex;
  align-items: flex-end;
}
.text_01 {
  width: 146px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}
.text-wrapper_01 {
  width: 330px;
  height: 19px;
  margin: -30px 0 10px 11px;
  /* border: 1px solid white; */
}
.homeBtn {
  color: #ffffff;
  //   margin: -30px 0 0 0;
  position: absolute;
  left: 1800px;
  top: 80px;
  width: 100px;
  height: 40px;
  background: url("../assets/按钮.png");
  background-size: contain;
  background-repeat: no-repeat;
}
.timeSelect {
  width: 306px;
  background-color: #1b569b;
  color: rgba(87, 246, 255, 1);
  font-size: 18px;
  border: 2px solid #00fff6;
  font-weight: bold;
}
</style>
